<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.invoice_id" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.amount_html" presetName="paragraph" />
    <email-text [contents]="data.company_name_html" presetName="paragraph" />
    <email-margin [height]="28" />
    <email-text [contents]="data.content_html" className="web-rt-contains-link" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
